<template>
  <div class="auth__header">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-md-5 col-xl-5 my-1">
          <div class="card p-3">
            <!-- Logo -->
            <div class="login-logo">
              <router-link to="/">
                <img
                  src="@/assets/img/UK-DION-LOGISTICS-LOGO-01.png"
                  alt=""
                  class="text-center"
                  style="width:100px;"
                  v-if="brand == 'DION LOGISTICS'"
                />
                <img src="@/assets/img/logo.png" class="text-center" v-else />
              </router-link>
            </div>
            <div class="login-box-body" v-if="businessProfile === null">
              <!-- Subheading -->
              <p class="text-center login-box-message--2 text-center mb-5">
                Create your corporate account
              </p>
              <!-- Form -->
              <form @submit.prevent="register">
                <!-- Business Name -->
                <div class="form-group">
                  <label for="business_name" class="form-label"
                    >Business Name</label
                  >
                  <input
                    type="text"
                    id="business_name"
                    class="form-control"
                    v-model.trim="business_name"
                    name="business_name"
                  />
                </div>
                <!-- Full Name -->
                <div class="form-group">
                  <label for="name" class="form-label">Your Name</label>
                  <input
                    type="text"
                    id="full_name"
                    class="form-control"
                    v-model.trim="full_name"
                    name="full_name"
                  />
                </div>
                <!-- address -->
                <div class="form-group">
                  <label for="address" class="form-label">Address</label>
                  <input
                    type="text"
                    id="address"
                    class="form-control"
                    v-model.trim="address"
                    name="address"
                  />
                </div>
                <!-- Email -->
                <div class="form-group">
                  <label for="email" class="form-label">Email Address</label>
                  <input
                    type="email"
                    id="email_address"
                    class="form-control"
                    v-model.trim="email_address"
                    name="email_address"
                  />
                </div>
                <!-- Phone Number -->
                <div class="form-group">
                  <label for="phone_number" class="form-label"
                    >Phone Number</label
                  >
                  <input
                    type="text"
                    id="phone_number"
                    class="form-control"
                    v-model.trim="phone_number"
                    name="phone_number"
                  />
                </div>
                <!-- Password -->
                <div class="form-group">
                  <div class="row">
                    <div class="col">
                      <label for="passsword" class="form-label">Password</label>
                    </div>
                  </div>
                  <!-- Input group -->
                  <div class="input-group input-group-merge">
                    <input
                      :type="passwordFieldType"
                      id="passsword"
                      name="passsword"
                      v-model.trim="password"
                      class="form-control form-control-appended"
                    />
                    <!-- Icon -->
                    <div
                      class="input-group-append"
                      @click="switchVisibility"
                      style="cursor: pointer;"
                    >
                      <span class="input-group-text custom-input-group-text">
                        <i :class="appendEyeIconType"></i>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- Button -->
                <button
                  class="button text-uppercase btn-lg btn-block mb-2"
                  :disabled="!formIsValid || loadingRegister"
                >
                  <span class="custom-loader" v-if="loadingRegister">
                    <loader-icon size="1.5x" class="custom-class"></loader-icon>
                    <span style="font-weight: 600; text-transform: initial;"
                      >Creating account...</span
                    >
                  </span>
                  <span v-else>
                    Register
                  </span>
                </button>
                <!-- Link -->
                <div class="text-center">
                  <p class="text-muted text-center">
                    Already have an account yet?
                    <router-link :to="{ name: 'Login' }">Login</router-link>.
                  </p>
                </div>
              </form>
            </div>
            <div class="login-box-body" v-else-if="businessProfile !== null">
              <!-- Subheading -->
              <p class="text-center login-box-message--2 text-center mb-5">
                Verify your corporate account
              </p>
              <p>
                Your account has been created successfully. Please check your
                email for an OTP to complete your registration
              </p>
              <!-- Form -->
              <form @submit.prevent="verifyOtp">
                <!-- address -->
                <div class="form-group">
                  <label for="otp" class="form-label">OTP</label>
                  <input
                    type="text"
                    id="otp"
                    class="form-control"
                    v-model.trim="otp"
                    name="otp"
                  />
                </div>
                <!-- Button -->
                <button
                  class="button text-uppercase btn-lg btn-block mb-2"
                  :disabled="!otpFormIsValid || otpLoading"
                >
                  <span class="custom-loader" v-if="otpLoading">
                    <loader-icon size="1.5x" class="custom-class"></loader-icon>
                    <span style="font-weight: 600; text-transform: initial;"
                      >Verifying otp...</span
                    >
                  </span>
                  <span v-else>
                    Verify Otp
                  </span>
                </button>
                <div class="text-center">
                  <p class="text-muted text-center" @click="resendOTP">
                    Didn't get OTP? Resend
                  </p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/services/api.service";

import Swal from "sweetalert2";

export default {
  name: "Login",
  data() {
    return {
      passwordFieldType: "password",
      appendEyeIconType: "feather-eye",
      business_name: "",
      full_name: "",
      address: "",
      email_address: "",
      phone_number: "",
      otp: "",
      password: "",
      brand: "",
      loadingRegister: false,
      otpLoading: false,
      businessProfile: null
    };
  },
  computed: {
    formIsValid() {
      return (
        this.business_name !== "" &&
        this.full_name !== "" &&
        this.address !== "" &&
        this.email_address !== "" &&
        this.phone_number !== "" &&
        this.password !== ""
      );
    },
    otpFormIsValid() {
      return this.otp !== "";
    }
  },
  methods: {
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
      this.appendEyeIconType =
        this.appendEyeIconType === "feather-eye"
          ? "feather-eye-off"
          : "feather-eye";
    },
    async register() {
      let data = {
        business_name: this.business_name,
        name: this.full_name,
        business_address: this.address,
        email: this.email_address,
        phone_number: this.phone_number,
        password: this.password
      };

      this.loadingRegister = true;

      try {
        const response = await ApiService.post(
          "business/create-new-account",
          data
        );
        this.loadingRegister = false;
        this.businessProfile = response.data.data.business_profile;
        Swal.fire({
          title: "Success",
          text: response.data.response_description,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
      } catch (error) {
        this.loadingRegister = false;
        console.log(error.response);
        Swal.fire({
          title: "Error!",
          text: error.response.data.data,
          icon: "error"
        });
      }
    },
    async verifyOtp() {
      let data = {
        email: this.businessProfile.business_email,
        otp: this.otp,
        type: "registration"
      };

      this.otpLoading = true;

      try {
        const response = await ApiService.post("general/otp/verify", data);
        this.otpLoading = false;

        Swal.fire({
          title: "Success",
          text: response.data.response_description,
          icon: "success",
          confirmButtonText: "Close",
          showConfirmButton: true
        }).then(result => {
          if (result.isConfirmed) {
            this.$router.push("/");
          }
        });
      } catch (error) {
        this.otpLoading = false;
        console.log(error.response);
        Swal.fire({
          title: "Error!",
          text: error.response.data.data,
          icon: "error"
        });
      }
    },
    async resendOTP() {
      try {
        const response = await ApiService.post("", data);
        console.log(response);
      } catch (error) {
        console.log(response);
      }
    }
  },
  mounted() {
    $("body").css("background", "#3d4f86");
    this.brand = "Capital Bank ADMIN";
  }
};
</script>

<style>
.auth__header {
  padding-top: 5rem;
}

.login-logo,
.register-logo {
  font-size: 35px;
  text-align: center;
  margin-bottom: 25px;
}

.login-box-message--1 {
  font-size: 40px;
  font-weight: 700;
  font-style: normal;
  color: #001833;
  line-height: 51.64px;
}

.login-box-message--2 {
  font-size: 25px;
  font-weight: 600;
  font-style: normal;
  color: #a2b3ca;
  line-height: 31.98px;
}

form .form-control {
  border: 1px solid #cacfe7;
  color: #3b4781;
  box-shadow: none !important;
  outline: none !important;
}

.form-label {
  font-size: 15px;
  font-weight: 600;
}

.input-group.input-group-merge > .form-control-appended {
  padding-right: 0.375rem;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-right-width: 0;
}

.input-group.input-group-merge > .input-group-append > .input-group-text {
  padding-left: 0.375rem;
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
  border-left-width: 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.custom-input-group-text {
  padding: 0.5rem 0.75rem;
  color: #95aac9;
  background-color: #fff;
}

.input-group.input-group-merge
  > .form-control:focus
  ~ [class*="input-group"]
  > .input-group-text {
  background-color: #fff;
  border-color: #1e9ff2;
  outline: 0;
  box-shadow: none;
}
</style>
